import { Link, createFileRoute } from '@tanstack/react-router';
import { FileQuestion } from 'lucide-react';

import { Button } from '@/shared/ui/shadcn/button';

export const Route = createFileRoute('/_private/404')({
  component: NotFoundPage,
});

function NotFoundPage() {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-4 p-6 text-center">
      <FileQuestion aria-hidden="true" className="size-10 text-muted-foreground" />
      <div className="space-y-1">
        <h1 className="text-xl font-semibold">Página no encontrada</h1>
        <p className="max-w-md text-sm text-muted-foreground">
          La ruta solicitada no existe o ha sido movida. Use el menú lateral o el atajo{' '}
          <kbd className="rounded bg-muted px-1.5 py-0.5 font-mono text-xs">⌘K</kbd> para buscar.
        </p>
      </div>
      <Button asChild variant="outline">
        <Link to="/dashboard">Volver al inicio</Link>
      </Button>
    </div>
  );
}
